export const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export const getStoredNavTheme = (): 'light' | 'realDark' | null => {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(NAV_THEME_STORAGE_KEY);
  if (value === 'light' || value === 'realDark') {
    return value;
  }
  return null;
};

export const saveNavTheme = (theme: 'light' | 'realDark') => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};
